import { render } from "./CreateCashRegister.vue?vue&type=template&id=aaaeab22"
import script from "./CreateCashRegister.vue?vue&type=script&lang=js"
export * from "./CreateCashRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__